import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import React, { useContext, useMemo, useState, useCallback, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import _createClass from '@babel/runtime/helpers/createClass';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _inherits from '@babel/runtime/helpers/inherits';
import _createSuper from '@babel/runtime/helpers/createSuper';
import { getJSON, getCSRFHeaders, postJSON } from '@folklore/fetch';
import { stringify, parse } from 'query-string';
import { generatePath } from 'react-router';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import isString from 'lodash/isString';
import { useVisitor, useStory } from '@micromag/core/contexts';

var Base = /*#__PURE__*/function () {
  function Base() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Base);
    this.options = _objectSpread(_objectSpread({
      routes: {}
    }, opts), {}, {
      baseUrl: opts.baseUrl || 'https://micromag.ca/api'
    });
  }
  _createClass(Base, [{
    key: "requestGet",
    value: function requestGet(path) {
      var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var queryString = query !== null ? stringify(query, {
        arrayFormat: 'bracket'
      }) : null;
      return getJSON("".concat(this.getFullUrl(path)).concat(queryString !== null && queryString.length > 0 ? "?".concat(queryString) : ''), {
        credentials: 'include',
        headers: getCSRFHeaders()
      });
    }
  }, {
    key: "requestPost",
    value: function requestPost(path, data) {
      return postJSON(this.getFullUrl(path), data, {
        credentials: 'include',
        headers: getCSRFHeaders()
      });
    }
  }, {
    key: "requestPut",
    value: function requestPut(path, data) {
      return postJSON(this.getFullUrl(path), _objectSpread({
        _method: 'PUT'
      }, data), {
        credentials: 'include',
        headers: getCSRFHeaders()
      });
    }
  }, {
    key: "requestDelete",
    value: function requestDelete(path) {
      return this.requestPost(path, {
        _method: 'DELETE'
      });
    }
  }, {
    key: "route",
    value: function route(_route, params) {
      var routes = this.options.routes;
      return generatePath(routes[_route] || _route, params);
    }
  }, {
    key: "getFullUrl",
    value: function getFullUrl(path) {
      var baseUrl = this.options.baseUrl;
      return "".concat(baseUrl.replace(/\/$/, ''), "/").concat(path.replace(/^\//, ''));
    }
  }]);
  return Base;
}();

var ContributionsApi = /*#__PURE__*/function (_Base) {
  _inherits(ContributionsApi, _Base);
  var _super = _createSuper(ContributionsApi);
  function ContributionsApi() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, ContributionsApi);
    return _super.call(this, _objectSpread(_objectSpread({}, opts), {}, {
      routes: _objectSpread({
        index: '/contributions/:screen',
        store: '/contributions',
        update: '/contributions/:contribution',
        "delete": '/contributions/:contribution'
      }, opts.routes || null)
    }));
  }
  _createClass(ContributionsApi, [{
    key: "get",
    value: function get(id) {
      var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var count = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 10;
      var finalQuery = _objectSpread({}, query);
      if (page !== null) {
        finalQuery.page = page;
      }
      if (count !== null) {
        finalQuery.count = count;
      }
      return this.requestGet(this.route('index', {
        screen: id
      }), finalQuery);
    }
  }, {
    key: "create",
    value: function create(data) {
      return this.requestPost(this.route('store'), data);
    }
  }]);
  return ContributionsApi;
}(Base);

var MediasApi = /*#__PURE__*/function (_Base) {
  _inherits(MediasApi, _Base);
  var _super = _createSuper(MediasApi);
  function MediasApi() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, MediasApi);
    return _super.call(this, _objectSpread(_objectSpread({}, opts), {}, {
      routes: _objectSpread({
        index: 'medias',
        tags: 'medias/tags',
        authors: 'medias/authors',
        requestDelete: 'medias/requestDelete/:media',
        show: 'medias/:media',
        store: 'medias',
        update: 'medias/:media',
        "delete": 'medias/:media'
      }, opts.routes || null)
    }));
  }
  _createClass(MediasApi, [{
    key: "find",
    value: function find(id) {
      return this.requestGet(this.route('show', {
        media: id
      }));
    }
  }, {
    key: "get",
    value: function get() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
      var finalQuery = _objectSpread({}, query);
      if (page !== null) {
        finalQuery.page = page;
      }
      if (count !== null) {
        finalQuery.count = count;
      }
      return this.requestGet(this.route('index'), finalQuery);
    }
  }, {
    key: "getTags",
    value: function getTags() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
      var finalQuery = _objectSpread({}, query);
      if (count !== null) {
        finalQuery.count = count;
      }
      return this.requestGet(this.route('tags'), finalQuery);
    }
  }, {
    key: "getAuthors",
    value: function getAuthors() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
      var finalQuery = _objectSpread({}, query);
      if (count !== null) {
        finalQuery.count = count;
      }
      return this.requestGet(this.route('authors'), finalQuery);
    }
  }, {
    key: "create",
    value: function create(data) {
      return this.requestPost(this.route('store'), data);
    }
  }, {
    key: "update",
    value: function update(id, data) {
      return this.requestPut(this.route('update', {
        media: id
      }), data);
    }
  }, {
    key: "requestDeleteMedia",
    value: function requestDeleteMedia(id) {
      return this.requestPost(this.route('requestDelete', {
        media: id
      }));
    }
  }, {
    key: "delete",
    value: function _delete(id) {
      return this.requestDelete(this.route('delete', {
        media: id
      }));
    }
  }]);
  return MediasApi;
}(Base);

var QuizApi = /*#__PURE__*/function (_Base) {
  _inherits(QuizApi, _Base);
  var _super = _createSuper(QuizApi);
  function QuizApi() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, QuizApi);
    return _super.call(this, _objectSpread(_objectSpread({}, opts), {}, {
      routes: _objectSpread({
        results: '/quiz/:screen',
        store: '/quiz',
        update: '/quiz/:quiz',
        "delete": '/quiz/:quiz'
      }, opts.routes || null)
    }));
  }
  _createClass(QuizApi, [{
    key: "results",
    value: function results(screenId) {
      return this.requestGet(this.route('results', {
        screen: screenId
      }));
    }
  }, {
    key: "create",
    value: function create(data) {
      return this.requestPost(this.route('store'), data);
    }
  }]);
  return QuizApi;
}(Base);

var Api = /*#__PURE__*/function (_Base) {
  _inherits(Api, _Base);
  var _super = _createSuper(Api);
  function Api() {
    var _this;
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Api);
    _this = _super.call(this, opts);
    _this.medias = new MediasApi(opts);
    _this.contributions = new ContributionsApi(opts);
    _this.quiz = new QuizApi(opts);
    return _this;
  }
  return _createClass(Api);
}(Base);

/* eslint-disable react/jsx-props-no-spreading */
var ApiContext = /*#__PURE__*/React.createContext(null);
var useApi = function useApi() {
  return useContext(ApiContext);
};
var propTypes$1 = {
  api: PropTypes.instanceOf(Api),
  baseUrl: PropTypes.string,
  children: PropTypes.node.isRequired
};
var defaultProps$1 = {
  api: null,
  baseUrl: undefined
};
var ApiProvider = function ApiProvider(_ref) {
  var initialApi = _ref.api,
    baseUrl = _ref.baseUrl,
    children = _ref.children;
  var previousApi = useApi();
  var api = useMemo(function () {
    return initialApi || previousApi || new Api({
      baseUrl: baseUrl
      // baseUrl: 'https://micromag.studio.test/api',
    });
  }, [previousApi, initialApi, baseUrl]);
  return /*#__PURE__*/React.createElement(ApiContext.Provider, {
    value: api
  }, children);
};
ApiProvider.propTypes = propTypes$1;
ApiProvider.defaultProps = defaultProps$1;

var useContributionCreate = function useContributionCreate() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    screenId = _ref.screenId,
    _ref$onSuccess = _ref.onSuccess,
    onSuccess = _ref$onSuccess === void 0 ? null : _ref$onSuccess;
  var api = useApi();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    creating = _useState2[0],
    setCreating = _useState2[1];
  var create = useCallback(function (data) {
    if (api === null) {
      return null;
    }
    setCreating(true);
    return api.contributions.create(_objectSpread({
      screen_id: screenId
    }, data)).then(function (response) {
      setCreating(false);
      if (onSuccess !== null) {
        onSuccess(response);
      }
      return response;
    });
  }, [api, setCreating, onSuccess, screenId]);
  return {
    create: create,
    creating: creating
  };
};

var useData = function useData(loadData) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$initialData = _ref.initialData,
    initialData = _ref$initialData === void 0 ? null : _ref$initialData,
    _ref$autoload = _ref.autoload,
    autoload = _ref$autoload === void 0 ? true : _ref$autoload;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var _useState5 = useState(initialData),
    _useState6 = _slicedToArray(_useState5, 2),
    data = _useState6[0],
    setData = _useState6[1];
  var load = useCallback(function () {
    var canceled = false;
    setLoading(true);
    var promise = loadData.apply(void 0, arguments).then(function (newData) {
      if (!canceled) {
        setData(newData);
        setLoading(false);
      }
      return newData;
    })["catch"](function (newError) {
      setError(newError);
      setLoading(false);
    });
    promise.cancel = function () {
      canceled = true;
      setLoading(false);
    };
    return promise;
  }, [loadData, setLoading, setData]);
  useEffect(function () {
    var loader = null;
    if (autoload) {
      loader = load();
    }
    return function () {
      if (loader !== null) {
        loader.cancel();
      }
    };
  }, [autoload, load]);
  return {
    data: data,
    load: load,
    loading: loading,
    error: error
  };
};

var _excluded$3 = ["data"];
var useContributions = function useContributions() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    screenId = _ref.screenId,
    _ref$opts = _ref.opts,
    opts = _ref$opts === void 0 ? {} : _ref$opts;
  var api = useApi();
  var _useState = useState(_toConsumableArray(new Array(10)).map(function (el, i) {
      return {
        name: "Nom ".concat(i + 1),
        message: "Message ".concat(i + 1)
      };
    })),
    _useState2 = _slicedToArray(_useState, 1),
    defaultContributions = _useState2[0];
  var loader = useCallback(function () {
    return api !== null ? api.contributions.get(screenId) : null;
  }, [api, screenId]);
  var _ref2 = api !== null ? useData(loader, opts) : {
      data: null
    },
    data = _ref2.data,
    request = _objectWithoutProperties(_ref2, _excluded$3);
  return _objectSpread({
    contributions: data || defaultContributions
  }, request);
};

var useItems$1 = function useItems(_ref) {
  var _ref$getPage = _ref.getPage,
    getPage = _ref$getPage === void 0 ? null : _ref$getPage,
    _ref$getItems = _ref.getItems,
    getItems = _ref$getItems === void 0 ? null : _ref$getItems,
    _ref$page = _ref.page,
    page = _ref$page === void 0 ? null : _ref$page,
    _ref$count = _ref.count,
    count = _ref$count === void 0 ? 10 : _ref$count,
    _ref$items = _ref.items,
    providedItems = _ref$items === void 0 ? null : _ref$items,
    _ref$pages = _ref.pages,
    initialPages = _ref$pages === void 0 ? null : _ref$pages,
    _ref$getPageFromRespo = _ref.getPageFromResponse,
    getPageFromResponse = _ref$getPageFromRespo === void 0 ? function (_ref2) {
      var _ref2$meta = _ref2.meta,
        currentPage = _ref2$meta.current_page,
        lastPage = _ref2$meta.last_page,
        total = _ref2$meta.total,
        items = _ref2.data;
      return {
        page: parseInt(currentPage, 10),
        lastPage: parseInt(lastPage, 10),
        total: parseInt(total, 10),
        items: items
      };
    } : _ref$getPageFromRespo,
    _ref$getItemsFromResp = _ref.getItemsFromResponse,
    getItemsFromResponse = _ref$getItemsFromResp === void 0 ? function (data) {
      return data;
    } : _ref$getItemsFromResp,
    _ref$onItemsLoaded = _ref.onItemsLoaded,
    onItemsLoaded = _ref$onItemsLoaded === void 0 ? null : _ref$onItemsLoaded,
    _ref$onPageLoaded = _ref.onPageLoaded,
    onPageLoaded = _ref$onPageLoaded === void 0 ? null : _ref$onPageLoaded,
    _ref$onLoaded = _ref.onLoaded,
    onLoaded = _ref$onLoaded === void 0 ? null : _ref$onLoaded,
    _ref$onError = _ref.onError,
    onError = _ref$onError === void 0 ? null : _ref$onError;
  var isPaginated = getPage !== null || initialPages !== null;
  var lastState = useRef(null);
  var initialState = useMemo(function () {
    var finalInitialPages = initialPages !== null ? initialPages.map(function (it) {
      return getPageFromResponse(it);
    }) : null;
    return {
      lastPage: finalInitialPages !== null ? finalInitialPages.reduce(function (currentLastPage, _ref3) {
        var initialLastPage = _ref3.lastPage;
        return initialLastPage > currentLastPage ? initialLastPage : currentLastPage;
      }, -1) : -1,
      total: finalInitialPages !== null ? finalInitialPages[0].total : (providedItems || []).length,
      loaded: providedItems !== null,
      loading: false,
      pages: finalInitialPages !== null ? finalInitialPages : null,
      items: null
    };
  }, [initialPages, providedItems]);
  var _useState = useState(initialState),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var lastPage = state.lastPage,
    loaded = state.loaded,
    loading = state.loading,
    stateItems = state.items,
    pages = state.pages,
    total = state.total;
  var items = providedItems || (isPaginated && pages !== null ? pages.reduce(function (pagesItems, _ref4) {
    var pageItems = _ref4.items;
    return pagesItems.concat(pageItems);
  }, []) : stateItems) || null;
  var updateState = function updateState(update) {
    return setState(_objectSpread(_objectSpread({}, state), update));
  };
  var updateFromResponse = function updateFromResponse(response) {
    var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var reset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (error !== null) {
      updateState({
        loaded: false,
        loading: false
      });
      throw error;
    }
    if (isPaginated) {
      var newPage = getPageFromResponse(response);
      var newPages = (reset ? [newPage] : [].concat(_toConsumableArray((pages || []).filter(function (it) {
        return it.page !== newPage.page;
      })), [newPage])).sort(function (a, b) {
        if (a === b) {
          return 0;
        }
        return a > b ? 1 : -1;
      });
      updateState({
        loaded: true,
        loading: false,
        lastPage: newPage.lastPage,
        total: newPage.total,
        pages: newPages
      });
      return newPage;
    }
    var newItems = _toConsumableArray(getItemsFromResponse(response));
    updateState({
      loaded: true,
      loading: false,
      items: newItems,
      total: newItems.length
    });
    return newItems;
  };
  var getNextPage = function getNextPage() {
    var allPages = lastPage !== -1 ? Array.call.apply(Array, [null].concat(_toConsumableArray(Array(lastPage)))).map(function (it, index) {
      return index + 1;
    }) : [];
    var remainingPages = allPages.filter(function (pageNumber) {
      return pages.findIndex(function (it) {
        return it.page === pageNumber;
      }) === -1;
    });
    var firstItem = remainingPages.length > 0 ? remainingPages.shift() : null;
    return firstItem !== null ? firstItem : null;
  };
  var loadItems = function loadItems(requestPage) {
    updateState({
      loading: true
    });
    var canceled = false;
    var request = isPaginated ? getPage(requestPage, count) : getItems();
    var promise = request.then(function (response) {
      return !canceled ? updateFromResponse(response) : Promise.reject();
    })["catch"](function (error) {
      return !canceled ? updateFromResponse(null, error) : Promise.reject();
    }).then(function (response) {
      if (isPaginated && onPageLoaded !== null) {
        onPageLoaded(response);
      } else if (!isPaginated && onItemsLoaded !== null) {
        onItemsLoaded(response);
      }
      if (onLoaded !== null) {
        onLoaded(response);
      }
      return response;
    })["catch"](function (error) {
      if (!canceled && onError !== null) {
        onError(error);
      }
    });
    promise.cancel = function () {
      canceled = true;
    };
    return promise;
  };
  var loadPage = function loadPage(pageToLoad) {
    if (loading) {
      return Promise.reject();
    }
    if (pages.find(function (it) {
      return it.page === pageToLoad;
    }) !== -1) {
      return Promise.reject();
    }
    return loadItems(pageToLoad);
  };
  var loadNextPage = function loadNextPage() {
    if (loading) {
      return Promise.reject();
    }
    var nextPage = getNextPage();
    return nextPage !== null ? loadItems(nextPage) : Promise.resolve();
  };
  useEffect(function () {
    var hadState = lastState.current !== null;
    lastState.current = initialState;
    if (hadState) {
      setState(initialState);
    }
  }, [initialState]);
  useEffect(function () {
    if (getPage === null && getItems === null || providedItems !== null) {
      return function () {};
    }
    var loadPromise = null;
    var pageToLoad = isPaginated && initialPages === null && page === null ? 1 : page;
    if (!isPaginated || pageToLoad !== null) {
      loadPromise = loadItems(pageToLoad);
    }
    return function () {
      if (loadPromise !== null) {
        loadPromise.cancel();
      }
    };
  }, [getPage, getItems, page]);
  var currentPage = isPaginated && pages !== null ? pages.find(function (_ref5) {
    var pageNumber = _ref5.page;
    return parseInt(pageNumber, 10) === parseInt(page, 10);
  }) || null : null;
  return {
    items: items,
    pages: pages,
    pageItems: currentPage !== null ? currentPage.items : null,
    total: total,
    lastPage: lastPage,
    loaded: loaded,
    allLoaded: !isPaginated && loaded || lastPage !== -1 && isPaginated && pages.length === lastPage,
    loading: loading,
    loadNextPage: loadNextPage,
    loadPage: loadPage
  };
};

var _excluded$2 = ["data"];
var useMedia = function useMedia(id, opts) {
  var api = useApi();
  var loader = useCallback(function () {
    return api.medias.find(id);
  }, [api, id]);
  var _useData = useData(loader, opts),
    data = _useData.data,
    request = _objectWithoutProperties(_useData, _excluded$2);
  return _objectSpread({
    story: data
  }, request);
};

// import { useCallback } from 'react';

// import useItems from './useItems';

// eslint-disable-next-line
var useMediaAuthors = function useMediaAuthors() {
  useApi(); // eslint-disable-line
  // console.log('api', api); // eslint-disable-line
  // const getItems = useCallback(() => api.medias.getAuthors(query, count), [api, query, count]);
  // const { items, pageItems, ...request } = useItems({
  //     getItems,
  //     ...opts,
  // });
  return {
    authors: []
    // ...request,
  };
};

var useMediaCreate = function useMediaCreate() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    creating = _useState2[0],
    setCreating = _useState2[1];
  var api = useApi();
  var create = useCallback(function (data) {
    setCreating(true);
    return api.medias.create(data).then(function (response) {
      setCreating(false);
      return response;
    });
  }, [api, setCreating]);
  return {
    create: create,
    creating: creating
  };
};

var useItems = function useItems(_ref) {
  var _ref$getPage = _ref.getPage,
    getPage = _ref$getPage === void 0 ? null : _ref$getPage,
    _ref$page = _ref.page,
    page = _ref$page === void 0 ? 1 : _ref$page,
    _ref$count = _ref.count,
    count = _ref$count === void 0 ? 10 : _ref$count,
    _ref$query = _ref.query,
    pageQuery = _ref$query === void 0 ? null : _ref$query,
    _ref$pages = _ref.pages,
    startingPages = _ref$pages === void 0 ? null : _ref$pages,
    _ref$getPageFromRespo = _ref.getPageFromResponse,
    getPageFromResponse = _ref$getPageFromRespo === void 0 ? function (newPage) {
      return newPage;
    } : _ref$getPageFromRespo,
    _ref$getPagination = _ref.getPagination,
    getPagination = _ref$getPagination === void 0 ? function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        cp = _ref2.current_page,
        pp = _ref2.per_page,
        lp = _ref2.last_page,
        total = _ref2.total;
      return {
        pageNumber: cp,
        pageCount: pp,
        lastPage: lp,
        total: total
      };
    } : _ref$getPagination,
    _ref$onLoaded = _ref.onLoaded,
    onLoaded = _ref$onLoaded === void 0 ? null : _ref$onLoaded,
    _ref$onError = _ref.onError,
    onError = _ref$onError === void 0 ? null : _ref$onError;
  // Pagination
  var _useState = useState(page !== null),
    _useState2 = _slicedToArray(_useState, 2),
    paginated = _useState2[0],
    setPaginated = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    pagination = _useState4[0],
    setPagination = _useState4[1];
  var _getPagination = getPagination(pagination || {}),
    _getPagination$pageNu = _getPagination.pageNumber,
    pageNumber = _getPagination$pageNu === void 0 ? page : _getPagination$pageNu,
    _getPagination$pageCo = _getPagination.pageCount,
    pageCount = _getPagination$pageCo === void 0 ? count : _getPagination$pageCo,
    _getPagination$lastPa = _getPagination.lastPage,
    lastPage = _getPagination$lastPa === void 0 ? null : _getPagination$lastPa,
    _getPagination$total = _getPagination.total,
    total = _getPagination$total === void 0 ? null : _getPagination$total;
  var _useMemo = useMemo(function () {
      return (startingPages || []).reduce(function (paginatedData, it) {
        var _ref3 = it || {},
          items = _ref3.data,
          currentPagination = _ref3.pagination;
        // eslint-disable-next-line no-param-reassign
        paginatedData.data = paginatedData.data.concat(items);
        // eslint-disable-next-line no-param-reassign
        paginatedData.pagination = currentPagination;
        return paginatedData;
      }, {
        data: [],
        pagination: {}
      });
    }, [startingPages]),
    initialPages = _useMemo.data,
    initialPagination = _useMemo.pagination;
  var _useState5 = useState(startingPages === null),
    _useState6 = _slicedToArray(_useState5, 2),
    canLoad = _useState6[0],
    setCanLoad = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    loading = _useState8[0],
    setLoading = _useState8[1];

  // Query
  var query = useMemo(function () {
    return _objectSpread({}, isString(pageQuery) ? parse(pageQuery || null, {
      arrayFormat: 'bracket'
    }) : pageQuery);
  }, [pageQuery]);

  // Items
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    items = _useState10[0],
    setItems = _useState10[1];
  var getPages = useCallback(function (newQuery, newPageNumber, newPageCount) {
    return getPage(newQuery, newPageNumber, newPageCount);
  }, [getPage]);

  // Api has changed, reset to beginning
  useEffect(function () {
    setItems(initialPages);
    setPagination(initialPagination);
  }, [getPages, setItems, setPagination]);
  useEffect(function () {
    // eslint-disable-next-line
    // console.log('try to load');
    if (!canLoad || loading || lastPage !== null && pageNumber > lastPage) {
      // console.log('skips loading');
      return;
    }
    // eslint-disable-next-line
    // console.log('actually load', canLoad, loading, lastPage, pageNumber);
    setLoading(true);
    setCanLoad(false);
    // TODO: make this a cancellable promise
    getPages(query, pageNumber, pageCount).then(function (response) {
      return getPageFromResponse(response);
    }).then(function (response) {
      var _ref4 = response || {},
        _ref4$data = _ref4.data,
        data = _ref4$data === void 0 ? null : _ref4$data,
        _ref4$meta = _ref4.meta,
        meta = _ref4$meta === void 0 ? null : _ref4$meta;
      // console.log('response --- ', response);
      //  This is not a paginated list so we dont care anymore
      if (data === null && meta === null) {
        setItems(response);
        setPaginated(false);
      } else {
        setItems(function (old) {
          return [].concat(_toConsumableArray(old || null), _toConsumableArray(data));
        });
        setPagination(meta);
        setPaginated(true);
      }
      return response;
    }).then(function (response) {
      setLoading(false);
      if (onLoaded !== null) {
        onLoaded(response);
      }
    })["catch"](function (e) {
      // Error is real
      setLoading(false);
      if (onError !== null) {
        onError(e);
      }
    });
  }, [query, pageNumber, canLoad, getPages, setLoading, setItems, setPagination, onLoaded, onError]);
  var reset = useCallback(function () {
    setItems([]);
    setPagination(null);
    setCanLoad(true);
  }, [setItems, setPagination, setCanLoad]);

  // Resets the game, "natural" refresh
  var onQueryChange = useEffect(function () {
    reset();
  }, [query, page, count, reset]);

  // Handle to Load next
  var loadNextPage = useCallback(function () {
    if (!loading && pageNumber < lastPage) {
      var params = _objectSpread(_objectSpread({}, pagination), {}, {
        current_page: pageNumber + 1,
        per_page: pageCount
      });
      setPagination(params);
      setCanLoad(true);
    }
  }, [query, pagination, pageNumber, pageCount, loading, lastPage, onQueryChange, setCanLoad]);
  var disabled = (items || []).length === 0 || loading || pageNumber >= lastPage || lastPage === null || lastPage === 1;
  var regularLoaded = !paginated && items !== null;
  var paginatedLoaded = !loading && items !== null && (items.length === total || pageNumber >= lastPage);
  return {
    items: items,
    total: total,
    page: pageNumber,
    count: pageCount,
    lastPage: lastPage,
    loading: loading,
    loaded: !loading,
    allLoaded: regularLoaded || paginatedLoaded,
    disabled: disabled,
    loadNextPage: loadNextPage,
    reset: reset
  };
};

var useMedias = function useMedias() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
  var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var api = useApi();
  var getPage = useCallback(function (newQuery) {
    var requestedPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var requestedCount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    return api.medias.get(newQuery, requestedPage, requestedCount);
  }, [api]);
  return useItems(_objectSpread({
    getPage: getPage,
    query: query,
    page: page,
    count: count
  }, opts));
};

var useMediasRecent = function useMediasRecent(opts) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'media-gallery-recent-searches';
  var createSearch = useCallback(function (value) {
    if (window !== undefined && value) {
      var recent = window.localStorage.getItem(key) || null;
      var current = recent !== null ? JSON.parse(recent || '[]') : [];
      var encoded = JSON.stringify([value].concat(_toConsumableArray(current)));
      window.localStorage.setItem(key, encoded);
      return true;
    }
    return false;
  }, [key]);
  var getSearches = useCallback(function () {
    var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
    if (window !== undefined) {
      var recent = window.localStorage.getItem(key) || null;
      var current = recent !== null ? JSON.parse(recent || '[]') : [];
      return current.slice(0, count);
    }
    return [];
  }, [key]);
  return {
    createSearch: createSearch,
    getSearches: getSearches
  };
};

var _excluded$1 = ["items", "pageItems"];
var useMediaTags = function useMediaTags() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var api = useApi();
  var getItems = useCallback(function () {
    return api.medias.getTags(query, count);
  }, [api, query, count]);
  var _useItems = useItems$1(_objectSpread({
      getItems: getItems
    }, opts)),
    items = _useItems.items;
    _useItems.pageItems;
    var request = _objectWithoutProperties(_useItems, _excluded$1);
  return _objectSpread({
    tags: items
  }, request);
};

var useMediaUpdate = function useMediaUpdate() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    updating = _useState2[0],
    setUpdating = _useState2[1];
  var api = useApi();
  var update = useCallback(function (id, data) {
    setUpdating(true);
    return api.medias.update(id, data).then(function (response) {
      setUpdating(false);
      return response;
    });
  }, [api, setUpdating]);
  return {
    update: update,
    updating: updating
  };
};

var useMediaRequestDelete = function useMediaRequestDelete() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    requesting = _useState2[0],
    setRequesting = _useState2[1];
  var api = useApi();
  var requestDeleteMedia = useCallback(function (id) {
    setRequesting(true);
    return api.medias.requestDeleteMedia(id).then(function (response) {
      setRequesting(false);
      return response;
    });
  }, [api, setRequesting]);
  return {
    requestDeleteMedia: requestDeleteMedia,
    requesting: requesting
  };
};

var useMediaDelete = function useMediaDelete() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    deleting = _useState2[0],
    setDeleting = _useState2[1];
  var api = useApi();
  var deleteMedia = useCallback(function (id) {
    setDeleting(true);
    return api.medias["delete"](id).then(function (response) {
      setDeleting(false);
      return response;
    });
  }, [api, setDeleting]);
  return {
    deleteMedia: deleteMedia,
    deleting: deleting
  };
};

var _excluded = ["data"];
var useQuiz = function useQuiz() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    screenId = _ref.screenId,
    _ref$opts = _ref.opts,
    opts = _ref$opts === void 0 ? {} : _ref$opts;
  var api = useApi();
  var loader = useCallback(function () {
    return api !== null ? api.quiz.results(screenId) : null;
  }, [api, screenId]);
  var _ref2 = api !== null ? useData(loader, opts) : {
      data: null
    },
    data = _ref2.data,
    request = _objectWithoutProperties(_ref2, _excluded);
  return _objectSpread({
    quiz: data || []
  }, request);
};

var useQuizCreate = function useQuizCreate() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    screenId = _ref.screenId,
    _ref$visitorId = _ref.visitorId,
    providedVisitorId = _ref$visitorId === void 0 ? null : _ref$visitorId,
    _ref$storyId = _ref.storyId,
    providedStoryId = _ref$storyId === void 0 ? null : _ref$storyId,
    _ref$onSuccess = _ref.onSuccess,
    onSuccess = _ref$onSuccess === void 0 ? null : _ref$onSuccess;
  var api = useApi();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    creating = _useState2[0],
    setCreating = _useState2[1];
  var _ref2 = useVisitor() || {},
    visitorId = _ref2.id;
  var _ref3 = useStory() || {},
    storyId = _ref3.id;
  var create = useCallback(function (data) {
    if (api === null) {
      return null;
    }
    setCreating(true);
    return api.quiz.create(_objectSpread({
      screen_id: screenId,
      visitor_id: providedVisitorId || visitorId,
      story_id: providedStoryId || storyId
    }, data)).then(function (response) {
      setCreating(false);
      if (onSuccess !== null) {
        onSuccess(response);
      }
      return response;
    });
  }, [api, setCreating, onSuccess, screenId, visitorId, storyId, providedVisitorId, providedStoryId]);
  return {
    create: create,
    creating: creating
  };
};

/* eslint-disable react/jsx-props-no-spreading */
var propTypes = {
  api: PropTypes.instanceOf(Api),
  apiBaseUrl: PropTypes.string,
  children: PropTypes.node
};
var defaultProps = {
  api: null,
  apiBaseUrl: undefined,
  children: null
};
var DataProvider = function DataProvider(_ref) {
  var api = _ref.api,
    apiBaseUrl = _ref.apiBaseUrl,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(ApiProvider, {
    api: api,
    baseUrl: apiBaseUrl
  }, children);
};
DataProvider.propTypes = propTypes;
DataProvider.defaultProps = defaultProps;

export { Api, ApiProvider, Base as BaseApi, DataProvider, useApi, useContributionCreate, useContributions, useData, useItems$1 as useItems, useMedia, useMediaAuthors, useMediaCreate, useMediaDelete, useMediaRequestDelete, useMediaTags, useMediaUpdate, useMedias, useMediasRecent as useMediasRecentSearches, useQuiz, useQuizCreate };
